const resources = { signInButton: 'Sign In', signInText: '  to see your loves list.', vosFavoris: 'Vos favoris apparaîtront ici.' };

export default function getResource(label) {
    return resources[label];
}
